import React from "react";

const PALETTE = [
  ["#2563eb", "#0f766e"],
  ["#7c3aed", "#db2777"],
  ["#ea580c", "#dc2626"],
  ["#0891b2", "#2563eb"],
  ["#059669", "#65a30d"],
  ["#be123c", "#c2410c"],
  ["#4338ca", "#0369a1"],
  ["#0f766e", "#14b8a6"],
  ["#b45309", "#ea580c"],
  ["#475569", "#334155"],
];

function hash(str = "") {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

function initials(name = "", fallback = "?") {
  const clean = String(name || "").trim();
  if (!clean) return fallback;
  const parts = clean.split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Avatar({ name, seed, size = "md" }) {
  const palette = PALETTE[hash(seed || name || "x") % PALETTE.length];
  const cls =
    size === "sm"
      ? "ou-avatar ou-avatar--sm"
      : size === "lg"
        ? "ou-avatar ou-avatar--lg"
        : "ou-avatar";
  const ini = initials(name);
  return (
    <span
      className={cls}
      style={{
        background: `linear-gradient(135deg, ${palette[0]}, ${palette[1]})`,
      }}
    >
      {ini}
    </span>
  );
}
